/**
 * Service for handling local storage operations
 * Implements persistence layer for application settings
 */
export class StorageService {
    static STORAGE_KEYS = {
        SETTINGS: 'standup-settings'
    };

    static DEFAULT_SETTINGS = {
        deadlineDuration: 5,
        projectDuration: 20,
        personalDuration: 2,
        randomOrder: false,
        teamMembers: [
            'Membro 1', 'Membro 2', 'Membro 3', 'Membro 4', 'Membro 5',
            'Membro 6', 'Membro 7', 'Membro 8', 'Membro 9'
        ]
    };

    /**
     * Load settings from localStorage
     * @returns {Object} Settings object
     */
    static loadSettings() {
        try {
            const stored = localStorage.getItem(this.STORAGE_KEYS.SETTINGS);
            return stored ? JSON.parse(stored) : { ...this.DEFAULT_SETTINGS };
        } catch (error) {
            console.error('Error loading settings:', error);
            return { ...this.DEFAULT_SETTINGS };
        }
    }

    /**
     * Save settings to localStorage
     * @param {Object} settings - Settings object to save
     */
    static saveSettings(settings) {
        try {
            localStorage.setItem(this.STORAGE_KEYS.SETTINGS, JSON.stringify(settings));
        } catch (error) {
            console.error('Error saving settings:', error);
        }
    }
}